export default "__VITE_ASSET__CiIgd2ye__"